module.exports = __webpack_public_path__ + "static/top_contact_bg-f841262ab15d1dca0c2e76e263d87ea8.jpg";